import React from "react";
import { VELLUM as T } from "../shared/folio/kit";

interface JobDetailSidebarProps {
  children: React.ReactNode;
  className?: string;
}

/* The sheet index.

   A dossier of this length needs a contents page, and on a drawing sheet
   the index sits in the left margin, ruled off from the body. It replaces
   the old right-hand rail: the act moved up into the masthead's title
   block, which left that rail holding nothing but a list of other posts,
   and those read far better full width than stacked in 320px. */
export const JobDetailSidebar: React.FC<JobDetailSidebarProps> = ({
  children,
}) => {
  return (
    <nav
      aria-label="Sections of this post"
      style={{
        alignSelf: "start",
        position: "sticky",
        top: 104,
        borderRight: `1px solid ${T.rule}`,
        paddingRight: 24,
      }}
      className="jd-index"
    >
      {children}
    </nav>
  );
};
